<!--
 * @Descripttion: 轮播表选择字段配置
 * @Author: zenghua.wang
 * @Date: 2021-10-25 15:21:07
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-10 17:04:52
-->
<template>
  <div>
    <el-form-item label="选择字段">
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        @click="onSetting"
      >选择</el-button>
    </el-form-item>

    <div style="margin: 10px 0">
      <el-table
        :data="data.option.column"
        v-loading="waitting"
        border
        size="small"
        style="width: 100%"
      >
        <el-table-column
          label="字段名"
          align="left"
          min-width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.prop }}
            <span v-if="scope.row.label">（{{ scope.row.label }}）</span>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="140"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-top"
              @click="sortField(scope.row, scope.$index, 'up')"
            ></el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-bottom"
              @click="sortField(scope.row, scope.$index, 'down')"
            ></el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-edit"
              @click="editField(scope.row, scope.$index)"
            ></el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-delete"
              @click="deleteField(scope.row, scope.$index, onRefresh)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 选择字段弹窗 -->
    <config-field-dialog
      :loading="loading"
      :dialog="dialog"
      :data="data"
      :column="column"
      @change="updateField($event, onRefresh)"
    />
  </div>
</template>
<script>
import apiField from '@/dragComponents/mixins/apiField.js'

import configFieldDialog from './fieldDialog.vue'
export default {
  name: 'config-field',
  mixins: [apiField],
  components: {
    configFieldDialog
  },
  props: {
    data: {
      type: [Array, Object]
    }
  },
  data() {
    return {}
  },
  methods: {
    onSetting() {
      let form = {
        label: '',
        prop: '',
        type: 'text',
        width: 'auto',
        align: 'center',
        color: '',
        dicFrom: '静态',
        dicData: []
      }
      this.addField(form)
    },
    onRefresh() {
      this.data.option.refresh = true
    }
  },
  mounted() {
    this.loadFeild()
  }
}
</script>
